module.exports = __webpack_public_path__ + "img/ill-home-slider-3.c8da7446.gif";